// frontend/src/admin/AdminContentNavigator.js
import React, { useState, useEffect } from 'react';
import './admincontentnavigator.css';
import AdminContentEditor from './AdminContentEditor';


const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const AdminContentNavigator = () => {
    const [subjects, setSubjects] = useState([]);
    const [chapters, setChapters] = useState([]);
    const [topics, setTopics] = useState([]);

    const [selectedSubject, setSelectedSubject] = useState('');
    const [selectedChapter, setSelectedChapter] = useState('');
    const [selectedTopic, setSelectedTopic] = useState('');

    // Stack of {level, entityId, entityName} — last item is the currently shown level
    const [stack, setStack] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/subjects/`).then(r => r.json()).then(setSubjects).catch(() => setError('Failed to load subjects'));
    }, []);

    useEffect(() => {
        if (!selectedSubject) { setChapters([]); return; }
        fetch(`${API_BASE}/chapters/?subject_id=${selectedSubject}`).then(r => r.json()).then(setChapters).catch(() => setError('Failed to load chapters'));
    }, [selectedSubject]);

    useEffect(() => {
        if (!selectedChapter) { setTopics([]); return; }
        fetch(`${API_BASE}/topics/?chapter_id=${selectedChapter}`).then(r => r.json()).then(setTopics).catch(() => setError('Failed to load topics'));
    }, [selectedChapter]);

    const openTopic = (topic) => {
        setStack([{ level: 'topic', entityId: topic.topic_id, entityName: topic.name }]);
    };

    const drillInto = (cardType, cardId, name) => {
        setStack(prev => [...prev, { level: cardType, entityId: cardId, entityName: name }]);
    };

    const goBack = () => {
        setStack(prev => prev.slice(0, -1));
    };

    const current = stack[stack.length - 1];

    return (
        <div className="acn-container">
            {!current && <h2>Content Editor</h2>}
            {error && <div className="ace-error">{error}</div>}

            {stack.length === 0 && (
                <div className="acn-selectors">
                    <div className="acn-field">
                        <label>Subject</label>
                        <select value={selectedSubject} onChange={(e) => { setSelectedSubject(e.target.value); setSelectedChapter(''); setSelectedTopic(''); }}>
                            <option value="">-- Select Subject --</option>
                            {subjects.map(s => <option key={s.subject_id} value={s.subject_id}>{s.name}</option>)}
                        </select>
                    </div>

                    <div className="acn-field">
                        <label>Chapter</label>
                        <select value={selectedChapter} onChange={(e) => { setSelectedChapter(e.target.value); setSelectedTopic(''); }} disabled={!selectedSubject}>
                            <option value="">-- Select Chapter --</option>
                            {chapters.map(c => <option key={c.chapter_id} value={c.chapter_id}>{c.name}</option>)}
                        </select>
                    </div>

                    <div className="acn-field">
                        <label>Topic</label>
                        <select value={selectedTopic} onChange={(e) => setSelectedTopic(e.target.value)} disabled={!selectedChapter}>
                            <option value="">-- Select Topic --</option>
                            {topics.map(t => <option key={t.topic_id} value={t.topic_id}>{t.name}</option>)}
                        </select>
                    </div>

                    <button
                        disabled={!selectedTopic}
                        onClick={() => openTopic(topics.find(t => String(t.topic_id) === String(selectedTopic)))}
                    >
                        Open Topic Editor
                    </button>
                </div>
            )}

            {current && (
                <AdminContentEditor
                    key={`${current.level}-${current.entityId}`}
                    level={current.level}
                    entityId={current.entityId}
                    entityName={current.entityName}
                    onDrillInto={drillInto}
                    onBack={stack.length > 0 ? goBack : null}
                />
            )}
        </div>
    );
};

export default AdminContentNavigator;